export default "__VITE_ASSET__cadca063__"